module.exports = __webpack_public_path__ + "static/media/close-circle.ac06edce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/close-circle.svg
// module id = 347
// module chunks = 0